'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of smart watch
 */ const SmartWatch = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3459_3182)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        x: "34",
                        y: "33",
                        width: "37",
                        height: "38",
                        fill: theme.ds5.asset[assetColor]["300"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M72.204 28.8719H31.8698C30.5874 28.8719 29.5469 29.9124 29.5469 31.1948V72.8059C29.5469 74.0882 30.5874 75.1288 31.8698 75.1288H72.204C73.4863 75.1288 74.5269 74.0882 74.5269 72.8059V31.192C74.5269 29.9097 73.4863 28.8691 72.204 28.8691V28.8719ZM69.392 69.9939H34.679V34.004H69.392V69.9939Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M67.4051 18.8066H36.6587L35.2188 28.8725H68.8451L67.4051 18.8066Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M36.6587 85.1967H67.4051L68.8451 75.1309H35.2188L36.6587 85.1967Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M49.0448 43.7852H54.9391V48.9784H60.1323V54.8727H54.9391V60.0659H49.0448V54.8727H43.8516V48.9784H49.0448V43.7852Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3459_3182",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "44.9773",
                        height: "66.3859",
                        fill: "white",
                        transform: "translate(29.5469 18.8066)"
                    })
                })
            })
        ]
    });
};

exports.SmartWatch = SmartWatch;
//# sourceMappingURL=SmartWatch.cjs.map
